export default "__VITE_ASSET__BhxhamlY__"